import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import HomeView from "./home/home";
import AboutUs from "./about/aboutus";
import PorfolioView from "./portfolio/portfolio";
import { Navbar, Nav } from "react-bootstrap";
//import ContactUs from "./contact/contact";
import ExperienceView from "./experience/experience";
import Footer from "./footer/footer";

function App() {
  return (
    <div>
      <Router>
        <div className="App container">
          <Navbar className="nav" collapseOnSelect variant="dark" bg="black" expand="md" sticky="top">
            {/* <Navbar.Brand href="/" className="font-weight-bold text-muted">
              Scratch
            </Navbar.Brand> */}
            <Navbar.Toggle />
            <Navbar.Collapse className="justify-content-end">
              <Nav>
              <Nav.Link href="#home">Home</Nav.Link>
                <Nav.Link href="#about">About Me</Nav.Link>
                <Nav.Link href="#experience">Experience</Nav.Link>
                <Nav.Link href="#portfolio">Portfolio</Nav.Link>
                {/* <Nav.Link href="/contact">Contact Me</Nav.Link> */}
                {/* <Nav.Link href="/portfolio">My Resume</Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <Routes />
        </div>
        <div className="container">
          <HomeView />
          {/* <Routes>
            <Route path="/home" element={<HomeView />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/portfolio" element={<PorfolioView />} />
            <Route path="/experience" element={<ExperienceView />} />
          </Routes> */}
          <AboutUs />
          <ExperienceView />
          <PorfolioView />
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
